<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M.5.5C.8.2 1.3 0 1.7 0c.5 0 .9.2 1.2.5L12 9.6 21.1.5c.2-.2.3-.3.6-.4.1 0 .3-.1.6-.1.2 0 .5 0 .7.1s.4.2.6.4c.2.2.3.4.4.6v.6c0 .2 0 .5-.1.7-.1.2-.2.4-.4.6l-9.1 9 9.1 9.1c.3.3.5.8.5 1.2 0 .4-.2.9-.5 1.2-.3.3-.7.5-1.2.5-.4 0-.9-.2-1.2-.5L12 14.4l-9.1 9.1c-.3.3-.7.5-1.2.5-.4 0-.9-.2-1.2-.5-.3-.3-.5-.8-.5-1.2 0-.4.2-.9.5-1.2L9.6 12 .5 3C.2 2.6 0 2.2 0 1.7 0 1.3.2.9.5.5z"
    />
  </svg>
</template>
